import loadable from '@loadable/component';

// 懒加载组件

const PlatformPointManagement = loadable(() => import('./platformPointManagement/PlatformPointManagement'));
const ItemPointDetailModify = loadable(() => import('./platformPointManagement/itemPointDetailModify/ItemPointDetailModify'));
const SupplierBillQuery = loadable(() => import('./supplierBillQuery/SupplierBillQuery'));
const SupplierBillManagement = loadable(() => import('./supplierBillManagement/SupplierBillManagement'));
const SupplierBillFinance = loadable(() => import('./supplierBillManagement/SupplierBillFinance'));
const SupplierHospitalItem = loadable(() => import('./supplierHospitalItem/SupplierHospitalItem'));
const CtpLevelManagement = loadable(() => import('./ctpLevelManagement/CtpLevelManagement'));
const SupplierBillSummaryQuery = loadable(() => import('./supplierBillSummaryQuery/SupplierBillSummaryQuery'));
const SupplierChargeBillQuery = loadable(() => import('./supplierChargeBillQuery/SupplierChargeBillQuery'));
const SupplierStatementQuery = loadable(() => import('./supplierStatementQuery/SupplierStatementQuery'));

// 2301
const SupplierBillManagement2301 = loadable(() => import('./supplierBillManagement2301/SupplierBillManagement2301'));
const SupplierBillFinance2301 = loadable(() => import('./supplierBillManagement2301/SupplierBillFinance2301'));
const SupplierBillSummaryQuery2301 = loadable(() => import('./supplierBillSummaryQuery2301/SupplierBillSummaryQuery2301'));
const SupplierBillQuery2301 = loadable(() => import('./supplierBillQuery2301/SupplierBillQuery2301'));
const SupplierInvoiceTitle = loadable(() => import('./supplierInvoiceTitle/SupplierInvoiceTitle'));
export const subRoutes = [
  {
    path: '/SupplierBillQuery',
    component: SupplierBillQuery
  },
  {
    path: '/SupplierChargeBillQuery',
    component: SupplierChargeBillQuery
  },
  {
    path: '/PlatformPointManagement',
    component: PlatformPointManagement
  },
  {
    path: '/SupplierBillManagement',
    component: SupplierBillManagement
  },
  {
    path: '/SupplierHospitalItem',
    component: SupplierHospitalItem
  },
  {
    path: '/ItemPointDetailModify',
    component: ItemPointDetailModify
  },
  {
    path: '/SupplierBillFinance',
    component: SupplierBillFinance
  },
  {
    path: '/CtpLevelManagement',
    component: CtpLevelManagement
  },
  {
    path: '/SupplierBillSummaryQuery',
    component: SupplierBillSummaryQuery
  },
  {
    path: '/SupplierStatementQuery',
    component: SupplierStatementQuery
  },

  // 2301
  {
    path: '/SupplierBillManagement2301',
    component: SupplierBillManagement2301
  },
  {
    path: '/SupplierBillFinance2301',
    component: SupplierBillFinance2301
  },
  {
    path: '/SupplierBillSummaryQuery2301',
    component: SupplierBillSummaryQuery2301
  },
  {
    path: '/SupplierBillQuery2301',
    component: SupplierBillQuery2301
  },
  {
    path: '/SupplierInvoiceTitle',
    component: SupplierInvoiceTitle
  }
];
